import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyHome = lazyWithRetry(() => import("./Home"));

const Home = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyHome {...props} />;

export default Home;
